// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__DXqYt","labelInput":"styles_labelInput__oiwL3","label":"styles_label__zRCGK","input":"styles_input__eIBD0"};